import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Drawer,
  FormFieldSet,
  InfoText,
  showToast,
} from "../../../components";
import pic from "../../../assets/images/profile-dummy.png";
import ChromeLogo from "../../../assets/logos/chrome_logo.svg";
import GmailLogo from "../../../assets/logos/gmail_logo.svg";
import GoogleLogo from "../../../assets/logos/google_logo.svg";
import OutlookLogo from "../../../assets/logos/outlook_logo_new.svg";
import Office365Logo from "../../../assets/logos/office365_logo.svg";
import TeamsLogo from "../../../assets/logos/teams_logo.svg";
import TwitterLogo from "../../../assets/logos/twitter_logo.svg";
import LinkedinLogo from "../../../assets/logos/linkedin_logo.svg";
import { keyToTitle } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { updateUserStart } from "../../../redux/slices/auth/authSlice";
import { formatWords2 } from "../../../utils/stringUtils";

const UserRoles = {
    1: "ADMIN",
    2: "RA",
    3: "BDM",
    4: "RECRUITER",
    5: "EMPLOYEE",
    6: "HR",
    7: "FINANCE",
    8: "IMMIGRATION",
    30: "OTHER"
}
const PersonalDetails = () => {
  const dispatch = useDispatch();
  const [editPrimaryDetails, setEditPrimaryDetails] = useState(false);
  const [editContactDetails, setEditContactDetails] = useState(false);
  const [editLocationDetails, setEditLocationDetails] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [firstName, setFirstName] = useState(user.data?.firstName || "");
  const [lastName, setLastName] = useState(user.data?.lastName || "");
  const [country,setCountry] = useState(user.data?.address?.country || "");
  const [state,setState] = useState(user.data?.address?.state || "");
  const [city,setCity] = useState(user.data?.address?.city || "");
  const [phone, setPhone] = useState({
  code: user.data?.mobile?.primary?.code || "",
  number: user.data?.mobile?.primary?.number || "",
});
  const [email, setEmail] = useState(user?.data?.email?.primary || "");

  const handleEditLocation = () => {
    const userAddress = user?.data?.address || {};
    setCountry(userAddress?.country || "");
    setState(userAddress?.state || "");
    setCity(userAddress?.city || "");
    setEditLocationDetails(true);
  };


  const handleCloseContactDrawer = () => {
    setEditContactDetails(false);
    setPhone({
      code: user?.data?.mobile?.primary?.code || "",
      number: user?.data?.mobile?.primary?.number || "",
    });
    setEmail(user?.data?.email?.primary || "");
  };

  const handleClosePrimaryDrawer = () => {
    setEditPrimaryDetails(false);
    setFirstName(user?.data?.firstName || "");
    setLastName(user?.data?.lastName || "");
  };

  const handleCloseLocationDrawer = () => {
    setEditLocationDetails(false);
    setCountry(user?.data?.address?.country || "");
    setState(user?.data?.address?.state || "");
    setCity(user?.data?.address?.city || "");
  };

  const handleUpdateUser = async (updateFields,onCloseDrawer) => {
    try {
      const payload = {
        id: user.data._id,
        payload: {
          $set: updateFields,
        },
      };

      dispatch(updateUserStart(payload));

      if (onCloseDrawer) onCloseDrawer();
    } catch (error) {
      console.error("Update failed", error);
      showToast("Failed to update","error");
    }
  };

  useEffect(() => {
  if (user?.data) {
    setFirstName(user?.data?.firstName || "");
    setLastName(user?.data?.lastName || "");
    setEmail(user?.data?.email?.primary || "");
    setPhone({
      code: user?.data?.mobile?.primary?.code || "",
      number: user?.data?.mobile?.primary?.number || "",
    });
    setCountry(user?.data?.address?.country || "");
    setState(user?.data?.address?.state || "");
    setCity(user?.data?.address?.city || "");
  }
}, [user]);
  return (
    <div className="flex flex-col p-3 gap-4">
      <div className="grid grid-cols-8 gap-4  ">
        <div className="col-span-2 flex flex-col border border-neutrals-300 rounded ">
          <div className="self-end">
            {user?.data?.role?.type === 1 && (<Button
              type="icon"
              size="xl"
              icon={"edit"}
              color="black"
              variant="text"
              onClick={() => setEditPrimaryDetails(true)}
            />)}
          </div>
          <div className="flex flex-col gap-2 py-3 justify-center items-center">
            <Avatar className="w-20 h-20" src={pic} />
            {/* <h4>Astha Vaish</h4> */}
            <h4>{formatWords2(user?.data?.firstName || "")} {formatWords2(user?.data?.lastName || "")}</h4>
            {/* <p className="text-neutrals-500">UI UX Designer</p> */}
            <p className="text-neutrals-500">{UserRoles[user?.data?.role?.type]}</p>
          </div>
        </div>
        <div className="col-span-3 border border-neutrals-300 rounded">
          <div className="flex justify-between items-center bg-neutrals-50 px-3 border-b border-neutrals-200">
            <h5>Contact Details</h5>
            <Button
              type="icon"
              size="xl"
              icon={"edit"}
              color="black"
              variant="text"
              onClick={() => setEditContactDetails(true)}
            />
          </div>
          <div className="flex flex-col py-3 px-2 gap-3">
            <InfoText
              size="sm"
              title={keyToTitle("Mobile")}
              // value={"+91 9875455465"}
              value={`${user?.data?.mobile?.primary?.code || ""} ${user?.data?.mobile?.primary?.number || ""}`}
            />
            <InfoText
              size="sm"
              title={keyToTitle("Email Address")}
              value={user?.data?.email?.primary || ""}
            />
          </div>
        </div>
        <div className="col-span-3 border border-neutrals-300 rounded">
          <div className="flex justify-between items-center bg-neutrals-50 px-3 border-b border-neutrals-200">
            <h5>Location</h5>
            <Button
              type="icon"
              size="xl"
              icon={"edit"}
              color="black"
              variant="text"
              // onClick={() => setEditLocationDetails(true)}
              onClick={handleEditLocation}
            />
          </div>
          <div className="grid grid-cols-2 p-3 gap-4">
            {/* <InfoText size="sm" title={keyToTitle("State")} value={"Dallas"} />
            <InfoText size="sm" title={keyToTitle("City")} value={"Seattle"} />
            <InfoText size="sm" title={keyToTitle("Country")} value={"USA"} /> */}
            <InfoText size="sm" title={keyToTitle("City")} value={user?.data?.address?.city || "-"} />
            <InfoText size="sm" title={keyToTitle("State")} value={user?.data?.address?.state || "-"} />
            <InfoText size="sm" title={keyToTitle("Country")} value={user?.data?.address?.country || "-"} />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="border border-neutrals-300 rounded">
          <div className=" bg-neutrals-50 p-3 border-b border-neutrals-200">
            <h5>Calender</h5>
          </div>
           <div className="grid xl:grid-cols-3  lg:grid-cols-2 gap-3 py-4 px-2">
            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={GoogleLogo} alt="Google" />
                  <span>Sync</span>
                </div>
              }
              className="!text-black font-semibold"
              onClick={() => showToast("Please contact Admin!","info")}
            />
            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={OutlookLogo} alt="Outlook" />
                  <span>Sync</span>
                </div>
              }
              className="!text-black font-semibold"
              onClick={() => showToast("Please contact Admin!","info")}
            />
          </div>
        </div>
        <div className="border border-neutrals-300 rounded">
          <div className=" bg-neutrals-50 p-3 border-b border-neutrals-200">
            <h5>Video Meetings</h5>
          </div>
           <div className="grid xl:grid-cols-3  lg:grid-cols-2 gap-3 py-4 px-2">
            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={GoogleLogo} alt="Google" />
                  <span>Link Account</span>
                </div>
              }
              className="!text-black font-semibold"
              onClick={() => showToast("Please contact Admin!","info")}
            />
            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={TeamsLogo} alt="Teams" />
                  <span>Link Account</span>
                </div>
              }
              className="!text-black font-semibold "
              onClick={() => showToast("Please contact Admin!","info")}
            />
          </div>
        </div>
        <div className="border border-neutrals-300 rounded">
          <div className=" bg-neutrals-50 p-3 border-b border-neutrals-200">
            <h5>Social Media Accounts</h5>
          </div>
        <div className="grid xl:grid-cols-3  lg:grid-cols-2 gap-3 py-4 px-2">

            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={GoogleLogo} alt="Google" />
                  <span>Link Account</span>
                </div>
              }
              className="!text-black font-semibold"
              onClick={() => showToast("Please contact Admin!","info")}
            />
            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={TwitterLogo} alt="Twitter" />
                  <span>Link Account</span>
                </div>
              }
              className="!text-black font-semibold"
              onClick={() => showToast("Please contact Admin!","info")}
            />
            <Button
              color="warning"
              variant="outlined"
              className="!text-black font-semibold"
              title={
                <div className="flex items-center gap-2">
                  <img src={LinkedinLogo} alt="Linkedin" />
                  <span>Link Account</span>
                </div>
              }
              onClick={() => showToast("Please contact Admin!","info")}
            />
          </div>
        </div>
        <div className="border border-neutrals-300 rounded">
          <div className=" bg-neutrals-50 p-3 border-b border-neutrals-200">
            <h5>Plugins</h5>
          </div>
         <div className="grid xl:grid-cols-3 lg:grid-cols-2 gap-3 py-4 px-2">
            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={ChromeLogo} alt="Chrome" />
                  <span>Chrome</span>
                </div>
              }
              className="!text-black font-semibold"
              onClick={() => showToast("Please contact Admin!","info")}
            />
            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={Office365Logo} alt="office365" />
                  <span>Office 365</span>
                </div>
              }
              className="!text-black font-semibold"
              onClick={() => showToast("Please contact Admin!","info")}
            />
            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={GmailLogo} alt="Gmail" />
                  <span>Gmail</span>
                </div>
              }
              className="!text-black font-semibold"
              onClick={() => showToast("Please contact Admin!","info")}
            />
            <Button
              color="warning"
              variant="outlined"
              title={
                <div className="flex items-center gap-2">
                  <img src={OutlookLogo} alt="Teams" />
                  <span>Outlook</span>
                </div>
              }
              className="!text-black font-semibold"
              onClick={() => showToast("Please contact Admin!","info")}
            />
          </div>
        </div>
      </div>
      <Drawer
        isOpen={editPrimaryDetails}
        title={"Edit Profile"}
        // onClose={() => setEditPrimaryDetails(false)}
        onClose={handleClosePrimaryDrawer}
        width="w-[50%]"
      >
        <div className="grid grid-cols-2 gap-3">
          <FormFieldSet title="First Name" placeholder="First Name" value={firstName} onChange={(value) => setFirstName(value)} />
          <FormFieldSet title="Last Name" placeholder="Last Name" value={lastName} onChange={(value) => setLastName(value)} />
        </div>
        <div className="flex justify-end items-center gap-3 my-4">
          <Button
            variant="outlined"
            title={"Cancel"}
            size="sm"
            onClick={handleClosePrimaryDrawer}
            // onClick={() => setEditPrimaryDetails(false)}
          />
          <Button title={"Save"} size="sm" 
            onClick={() =>
              handleUpdateUser(
                {
                  firstName,
                  lastName,
                },
                handleClosePrimaryDrawer
              )
            }
          />
        </div>
      </Drawer>
      <Drawer
        isOpen={editContactDetails}
        title={"Edit Contact Detail"}
        // onClose={() => setEditContactDetails(false)}
        onClose={handleCloseContactDrawer}
        width="w-[50%]"
      >
        <div className="grid grid-cols-2 gap-3">
          {/* <FormFieldSet 
          title="Mobile" 
          placeholder="Mobile"
          type="phoneNew" 
          values={[phone]}
          onChange={(value) => {
            // value[0] will be the object { code, number }
            setPhone(value[0]);
          }}
          /> */}
          <FormFieldSet
            title="Mobile"
            type="phone"
            placeholder="Enter Mobile Number"
            // value={
            //   phone?.fullNumber ||
            //   (phone?.code && phone?.number ? `${phone.code}${phone.number}` : "")
            // }
            value={phone?.number || ""}
            code={phone?.code || ""}
            onChange={(fullValue, details) => 
              setPhone({
                code: details.countryCode,
                number: details.number,
                fullNumber: details.fullNumber,
              })
            }
            shadow
          />

          <FormFieldSet title="Email Address" placeholder="Email Address" 
          value={email}
          onChange={(value) => setEmail(value)}
          />
        </div>
        <div className="flex justify-end items-center gap-3 my-4">
          <Button
            variant="outlined"
            title={"Cancel"}
            size="sm"
            // onClick={() => setEditPrimaryDetails(false)}
            onClick={handleCloseContactDrawer}
          />
          <Button title={"Save"} size="sm" 
          onClick={() =>
            handleUpdateUser(
              {
                email: { primary: email },
                mobile: { primary: phone },
              },
              handleCloseContactDrawer
            )
          }
          />
        </div>
      </Drawer>
      <Drawer
        isOpen={editLocationDetails}
        title={"Edit Location"}
        // onClose={() => setEditLocationDetails(false)}
        onClose={handleCloseLocationDrawer}
        width="w-[50%]"
      >
        <div className="grid grid-cols-2 gap-3">
          {/* <FormFieldSet title="City" placeholder="City" />
          <FormFieldSet title="State" placeholder="State" />
          <FormFieldSet title="Country" placeholder="Country" /> */}
          <FormFieldSet 
           type="countriesUsAndCanada"
          title="Country" 
          placeholder="Country"
          value={country} 
          onChange={(value) =>{
             setCountry(value.value)
          }}
          />
          <FormFieldSet 
          type="states"
          showSearch
          title="State" 
          placeholder="State" 
          value={state}
          onChange={(value) => setState(value.value)}
          parentValue={{ country:country }}
          disabled={!country}
          />
          <FormFieldSet
          type="cities"
          showSearch 
          title="City" 
          placeholder="City"
           value={city}
           onChange={(value) => setCity(value.value)}
           parentValue={{
              country: country,
              state: state,
            }}
            disabled={!state}
          />
        </div>
        <div className="flex justify-end items-center gap-3 my-4">
          <Button
            variant="outlined"
            title={"Cancel"}
            size="sm"
            // onClick={() => setEditPrimaryDetails(false)}
            onClick={handleCloseLocationDrawer}
          />
          <Button title={"Save"} size="sm"
          onClick={() =>
            handleUpdateUser(
              {
                address: {
                  country : country,
                  state : state,
                  city: city,
                },
              },
              handleCloseLocationDrawer
            )
          }
          />
        </div>
      </Drawer>
    </div>
  );
};

export default PersonalDetails;
